import React from 'react';
import PropTypes from "prop-types";
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';

const DomainStatusModal = ({
    heading,
    subHeading,
    imgSrc,
    colHeading,
    colSubHeading,
    colLink,
    children,
}) => {
    return (
        <div className="website-modal-wrap">
            <Row noGutters className="website-mod-content-wrap">
                <Col className="website-con-image">
                    <img src={imgSrc} />
                    <div className="mod-img-des">
                        <p className="mod-img-heading">{colHeading}</p>
                        <div className="mod-image-subheading-wrap">
                            <a href={colLink} target='_blank' className="mod-image-subheading">
                                {colSubHeading}
                            </a>
                            <svg
                                width="6"
                                height="6"
                                viewBox="0 0 6 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M3.66667 0V0.666667H4.86333L1.58667 3.94333L2.05667 4.41333L5.33333 1.13667V2.33333H6V0H3.66667ZM5.33333 5.33333H0.666667V0.666667H3V0H0.666667C0.489856 0 0.320286 0.0702379 0.195262 0.195262C0.0702379 0.320286 0 0.489856 0 0.666667V5.33333C0 5.51014 0.0702379 5.67971 0.195262 5.80474C0.320286 5.92976 0.489856 6 0.666667 6H5.33333C5.51014 6 5.67971 5.92976 5.80474 5.80474C5.92976 5.67971 6 5.51014 6 5.33333V3H5.33333V5.33333Z"
                                    fill="#060000"
                                    fillOpacity="0.7"
                                />
                            </svg>
                        </div>
                    </div>
                </Col>
                <Col className="website-mod-right-wrap">
                    <div className="website-mod-top-title-wrap">
                        <p className="website-mod-right-heading">{heading}</p>
                        <p className="website-mod-right-subheading">{subHeading}</p>
                    </div>
                    {children}
                </Col>
            </Row>
        </div>
    );
}

export default DomainStatusModal;